import styled from 'styled-components';
import { BasePanel } from 'styles/components';
export { TruckIcon, LinkButton, PlusIcon } from 'styles/components';

export const MainPanel = styled(BasePanel)`
  padding: 32px;
  flex-direction: column;
`;
